// src/components/pages/DMCAPolicy.js

import React from 'react';
import LegalPage from './LegalPage';

export default function DMCAPolicy() {
    return (
        <div>
            <LegalPage pageType="dmca_policy" />
        </div>
    );
}
